import Swiper from "swiper";
import "swiper/css";

const updateSlideStyles = (swiper) => {
  const slides = document.querySelectorAll(".mySwiperTextures .swiper-slide");
  const activeIndex = swiper.activeIndex;

  slides.forEach((slide, index) => {
    const distance = Math.abs(index - activeIndex);

    if (distance <= 10) {
      slide.classList.add("visible");
    } else {
      slide.classList.remove("visible");
    }

    let scale = 1;
    if (distance === 1) scale = 1;
    else if (distance === 2) scale = 0.9;
    else if (distance >= 3) scale = 0.8;

    slide.style.transition = "transform 0.3s ease-out";
    slide.style.transform = `scale(${scale})`;
  });
};

export const initWatchVariantsSwiper = (onActiveIndexChange) => {
  const defaultSwiperConfig = {
    slidesPerView: 5,
    spaceBetween: 12,
    slideToClickedSlide: true,
    centeredSlides: true,
    initialSlide: 1,
    direction: "horizontal",
    allowTouchMove: true,
  };

  const swiper = new Swiper(".mySwiperTextures", defaultSwiperConfig);

  // Apply initial scaling
  setTimeout(() => updateSlideStyles(swiper), 100);

  swiper.on("activeIndexChange", function () {
    updateSlideStyles(swiper);
    onActiveIndexChange(swiper.activeIndex);
  });

  swiper.on("slideChange", function () {
    updateSlideStyles(swiper);
  });

  return swiper;
};
